import {
  loadBrandConfiguration,
  type LoadBrandConfigurationOptions,
  type SharedBrandState
} from './loadPublishedConfig'
export interface BrandConfigStore<TConfig extends object> {
  // Filled in place by load(), so references taken after boot stay valid.
  readonly config: TConfig
  isPublished: () => boolean
  // The host's brands and the one booted; null unless the host is shared.
  sharedBrands: () => SharedBrandState | null
  load: () => Promise<TConfig>
}

export const createBrandConfigStore = <TApp, TConfig extends object>(
  options: LoadBrandConfigurationOptions<TApp, TConfig>
): BrandConfigStore<TConfig> => {
  const config = {} as TConfig
  let published = false
  let shared: SharedBrandState | null = null

  const replace = (next: Partial<TConfig>) => {
    for (const key of Object.keys(config)) {
      delete config[key as keyof TConfig]
    }
    Object.assign(config, next)
  }

  const load = async (): Promise<TConfig> => {
    published = false
    shared = null
    replace({})

    const result = await loadBrandConfiguration<TApp, TConfig>(options)

    replace(result.config)
    published = result.source !== 'legacy'
    shared = result.shared ?? null
    return config
  }

  return { config, isPublished: () => published, sharedBrands: () => shared, load }
}
